import { defineComponent, h } from 'vue';
import { QSelect, QIcon } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';

export default defineComponent({
    name: 'form-select',
    components: { QSelect, QIcon },
    data: function () {
        return {
            condition_expn: null
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
    },
    methods: {
        ...methods,
        getItemProps(item) {
            return {
                title: item.text,
                value: item.value,
                disabled: item.disabled,
            };
        },
        sync(prop, value) {
            if (Array.isArray(this.cmodel))
            {
                if (prop < this.cmodel.length)
                    this.cmodel[prop] = value
                else {
                    while (this.cmodel.length < prop)
                        this.cmodel.push(null);

                    this.cmodel.push(value);
                }
            }
            else
            {
                    this.cmodel[prop] = value
            }
        }
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        schema: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
        propertygrid: false,
    },
    render() {
        if (!this.Condition)
            return null;

        let desc;
        if (this.schema.description)
            desc = <i class="mdi mdi-information" title={this.schema.description} style={{ color: "var(--v-checkboxGrey-base)", fontSize: "small", marginLeft: "3px" }}></i>;

        let err;
        if (this.schema.formatData?.error)
            err = utils.tt(this.schema.formatData.error, <QIcon name="mdi-alert" size="xs" color="negative" />);

        const name = <span style={{ marginLeft: (this.child * 15) + "px" }}>{this.name}</span>;
        const schema = this.schema;
        const enumItems = schema.enum || schema.titleMap || [];

        if (this.readonly)
            return (
                <tr>
                    <td style={{ width: "1px" }}>
                        <span style={{ whiteSpace: "nowrap" }}>{name} {desc}{err}</span>
                    </td>
                    <td class={{ "property-grid": this.propertygrid }} style={{ whiteSpace: "nowrap", ...(this.propertygrid ? { minWidth: 0 } : {}) }}>
                        <QSelect
                            outlined
                            dense
                            hide-bottom-space
                            class="pa-0 ma-0"
                            popup-content-class="q-select-max-popup-height"
                            style={this.propertygrid ? { width: "100%", minWidth: 0 } : undefined}
                            readonly
                            modelValue={this.cmodel[this.schemakey]}
                            option-label="name"
                            options={enumItems}
                            emit-value
                            map-options />
                    </td>
                </tr>
            );

        if (schema.formatData && schema.formatData.AllowCustomInput) {
            return (
                <tr>
                    <td style={{ width: "1px" }}>
                        <span style={{ whiteSpace: "nowrap" }}>{name} {desc}{err}</span>
                    </td>
                    <td class={{ "property-grid": this.propertygrid }} style={{ whiteSpace: "nowrap", ...(this.propertygrid ? { minWidth: 0 } : {}) }}>
                        <QSelect
                            outlined dense hide-bottom-space
                            use-input
                            fill-input
                            hide-selected
                            new-value-mode="add-unique"
                            emit-value
                            map-options
                            class="pa-0 ma-0"
                            popup-content-class="q-select-max-popup-height"
                            style={this.propertygrid ? { width: "100%", minWidth: 0 } : undefined}
                            inputStyle={this.propertygrid ? { minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" } : undefined}
                            modelValue={this.cmodel[this.schemakey]}
                            options={enumItems}
                            option-label="name"
                            onNewValue={(e) => { console.log(`NewValue:QSelect:${e}`); this.sync(this.schemakey, e); }}
                            onInputValue={(e) => { console.log(`InputValue:QSelect:${e}`); this.sync(this.schemakey, e); }} />
                    </td>
                </tr>
            );
        }

        const items = [];
        const enums = schema.enum || schema.titleMap;
        if (Array.isArray(enums)) {
            if (!this.cmodel[this.schemakey])
                items.push({ text: "Please select one", value: "", disabled: true });
            else if (schema.$allows_null)
                items.push({ text: "", value: null, disabled: false });

            for (var i = 0; i < enums.length; i++) {
                const item = enums[i];
                if (item && typeof item === 'object')
                {
                    items.push({ text: item.name, value: item.value, disabled: false });
                }
                else
                {
                    items.push({ text: item, value: item, disabled: false });
                }
            }
        }

        return (
            <tr>
                <td style={{ width: "1px" }}>
                    <span style={{ whiteSpace: "nowrap" }}>{name} {desc}{err}</span>
                </td>
                <td class={{ "property-grid": this.propertygrid }} style={{ whiteSpace: "nowrap", ...(this.propertygrid ? { minWidth: 0 } : {}) }}>
                    <QSelect
                        outlined dense hide-bottom-space
                        class="pa-0 ma-0"
                        popup-content-class="q-select-max-popup-height"
                        style={this.propertygrid ? { width: "100%", minWidth: 0 } : undefined}
                        modelValue={this.cmodel[this.schemakey]}
                        options={items}
                        option-label="text"
                        option-value="value"
                        emit-value
                        map-options
                        onUpdate:modelValue={(value) => this.sync(this.schemakey, value)} />
                </td>
            </tr>
        );
    }
});